// extracted by mini-css-extract-plugin
export default {"textInput":"JsonField_textInput__zI+5+","buttons":"JsonField_buttons__fLsOs","fieldsContainer":"JsonField_fieldsContainer__Gi8SG"};